export const CONTRACT_ADDITIONAL_ADD_REQUEST = 'CONTRACT_ADDITIONAL_ADD_REQUEST'
export const CONTRACT_ADDITIONAL_ADD_SUCCESS = 'CONTRACT_ADDITIONAL_ADD_SUCCESS'
export const CONTRACT_ADDITIONAL_ADD_ERROR = 'CONTRACT_ADDITIONAL_ADD_ERROR'